import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Form, Col, Container, Row, Accordion, Card } from 'react-bootstrap';
import { Field, ErrorMessage } from 'formik';
import { DropdownList } from 'react-widgets';
import { isEmpty, capitalize } from 'lodash';
import { isMobileOnly } from 'react-device-detect';

import CustomValidatedSelect from '../../../../core-components/CustomValidatedSelect';
import countryNames from '../../../../utils/countryNamesEn.json';
import countryOptions from '../../../../utils/countryCodesEn.json';
import ValidatedFormInputField from '../../../../core-components/ValidatedFormInputField';
import ValidatedRadioFields from '../../../../core-components/ValidatedRadioFields';
import Button from '../../../../core-components/Button';
import ValidatedFileSelect from '../../../../core-components/ValidatedFileSelect';
import Checkbox from '../../../../core-components/Checkbox';
import {
  isValidPhoneNumber,
  jwtParser,
  getTrimmedValue,
  getErrorMessage,
  isTrimmedPhoneValid
} from '../../../../utils/utilities';
import {
  checkCandidateEmail as checkCandidateEmailAPI,
  checkCandidatePhone as checkCandidatePhoneAPI,
  checkCandidateEmployeeId as checkCandidateEmployeeIdAPI
} from '../../../../api/company';
import localStorage from '../../../../api/localStorage';
import CategoryModals from '../../CategoryModals';
import AdminModals from '../../Administrators/AdminModals';
import Image from '../../../../core-components/Image';

import styles from './BasicDetails.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
const tagDropdownStyles = {
  option: (provided, state) => ({
    ...provided,
    fontFamily: 'Poppins',
    fontSize: '14px',
    lineHeight: '21px',
    color: '#666666',
    borderRadius: '4px',
    padding: '10px 20px',
    border: 'none',
    background: state.isFocused ? '#ffffff' : ''
  }),
  control: (provided) => ({
    ...provided,
    border: '1px solid #ebedf2',
    boxSizing: 'border-box',
    borderRadius: '4px',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
    display: 'flex'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#333333'
    };
  },
  valueContainer: (base) => ({
    ...base
  }),
  container: (base) => ({
    ...base
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: '10'
  })
};
const tagsSeparator = ({ innerProps }) => {
  return <span style={{ display: 'none' }} {...innerProps} />;
};

export default (props) => {
  const [isAdmin, setIsAdmin] = useState(localStorage.getAccessLevel() === 'admin');
  const [companyId, setCompanyId] = useState(
    new URLSearchParams(document.location.search).get('id') || null
  );
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showCatModal, setShowCatModal] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);
  const [isUploading, setIsUploading] = useState(null);
  const [isConsentUploading, setIsConsentUploading] = useState(null);
  const [resumeError, setResumeError] = useState(false);
  const [consentError, setConsentError] = useState(false);
  const [bgvFiller, setBgvFiller] = useState([
    { value: '1', label: 'Ask Candidate', disable: true },
    { value: '2', label: "I'll fill it" }
  ]);
  const [activeAccordion, setActiveAccordion] = useState(null);

  const { handleSubmit, isSubmitting, values, errors,setFieldValue, touched } = props;
  const charCount = values?.hrInviteNote?.trim()?.length;
  const token = localStorage.getToken();
  const parsedJwtDetail = jwtParser(token);
  useEffect(() => {
    if (
      (!values.formConfig.isEmailOptional && values.email) ||
      (values.formConfig.isEmailOptional && values.email)
    ) {
      setFieldValue('invite', '1');
      setBgvFiller([
        { value: '1', label: 'Ask Candidate' },
        { value: '2', label: "I'll fill it" }
      ]);
    } else {
      setFieldValue('invite', '2');
      setBgvFiller([
        { value: '1', label: 'Ask Candidate', disable: true },
        { value: '2', label: "I'll fill it" }
      ]);
    }
  }, [values.email]);

  // if we coming back to this page via go back button then set the value based on saved values which user has seected while filling basic details
  useEffect(() => {
    if (props?.isGoingBackToStep1) {
      setFieldValue('invite', props?.savedValues?.invite ? '1' : '2');
    }
  }, [props?.isStep2]);
  const setValue = (fieldname, value, withSpace) => {
    const trimmedVal = getTrimmedValue(value, withSpace);
    setFieldValue(fieldname, trimmedVal);
    return trimmedVal;
  };
  let isValidForm =
    !isSubmitting &&
    isEmpty(errors) &&
    !values.phoneNumberExists &&
    !isUploading &&
    !isConsentUploading &&
    !values.emailExists &&
    !values.employeeIdExists &&
    values?.isValidPhone &&
    values?.isAltValidPhone &&
    ((values.email && values.consentDoc) ||
      values.consentLink ||
      values?.isConsentUndertakingLetter === '1') &&
    !resumeError &&
    (values?.hrInviteNote?.trim() ? (charCount >= 10 && charCount <= 160 ? true : false) : true);

  if (values?.consentFile?.name && values?.consentFile?.name !== '') {
    isValidForm &&= !consentError;
  }

  const propsCategory = props?.createCandConfig?.categories
    ? props?.createCandConfig?.categories
    : [];
  const categories = [{ id: '', categoryName: 'No Category' }, ...propsCategory];
  const refreshTags = () => {
    props.getAddCandidateConfig(companyId);
  };

  const onChangeInvite = (e) => {
    setFieldValue('invite', e.target.value);
  };

  const decoratedOnClick = (eventKey = 0) => {
    if (eventKey === activeAccordion) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(eventKey);
    }
  };
  return (
    <>
      <Container>
        <div className={styles.addCandidate}>
          <Row>
            <Col md={4}>
              <h3 className={styles.heading}>Add candidate details</h3>
            </Col>
            <Col md={8} className={styles.form}>
              <Form onSubmit={handleSubmit}>
                <Form.Group className='mb-3' controlId='formBasicEmail'>
                  <Form.Label>
                    Name <span>*</span>
                  </Form.Label>
                  <Field
                    type='text'
                    name='name'
                    fieldWithoutSpace={false}
                    component={ValidatedFormInputField}
                    onBlur={(e) => {
                      props?.handleBlur(e);
                      setValue('name', values?.name, true);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    Email
                    {!values.formConfig.isEmailOptional ? <span>*</span> : null}
                  </Form.Label>
                  <Field
                    type='text'
                    name='email'
                    className={values.emailExists || values.emailInvalid ? styles.emailError : null}
                    component={ValidatedFormInputField}
                    onBlur={(e) => {
                      props?.handleBlur(e);
                      const trimedEmailValue = setValue('email', values?.email, false);
                      if (trimedEmailValue && !errors.email) {
                        checkCandidateEmailAPI(trimedEmailValue)
                          .then((response) => {
                            if (response.data.data.data) {
                              setFieldValue('emailExists', true);
                            } else {
                              setFieldValue('emailExists', false);
                            }
                          })
                          .catch((error) => {
                            setFieldValue('emailExists', false);
                          });
                      }
                    }}
                  />
                  {!errors.email && values.emailExists && (
                    <div className={styles.emailErrorMsg}>
                      {values.emailExists ? 'Email already exists' : ''}
                    </div>
                  )}
                </Form.Group>
                <Form.Group>
                  <Form.Label>Alt. Email</Form.Label>
                  <Field
                    type='text'
                    name='alternateEmail'
                    component={ValidatedFormInputField}
                    onBlur={(e) => {
                      props?.handleBlur(e);
                      setValue('alternateEmail', values?.alternateEmail, false);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    Mobile Number <span>*</span>
                  </Form.Label>
                  <Form.Row>
                    {!isMobileOnly ? (
                      <Field
                        type='text'
                        name='countryCode'
                        defaultValue={values.countryCode}
                        options={countryNames}
                        className='countryCodeDropDown'
                        filterLabel={countryOptions}
                        component={CustomValidatedSelect}
                        onChange={(e) => {
                          if (values.phone && e) {
                              isTrimmedPhoneValid(e, values.phone, setFieldValue, 'isValidPhone');
                            let intlPhoneNumber = `${e + '' + values.phone}`;
                            checkCandidatePhoneAPI(intlPhoneNumber)
                              .then((response) => {
                                if (response.data.data.data !== null) {
                                  setFieldValue('phoneNumberExists', true);
                                } else {
                                  setFieldValue('phoneNumberExists', false);
                                }
                              })
                              .catch((error) => {
                    setFieldValue('phoneNumberExists', false);
                              });
                          }
                        }}
                        onBlur={(e) => {
                          this.props?.handleBlur(e);
                          setValue('phone', values?.phone, false);
                        }}
                      />
                    ) : (
                      <Form.Group
                        as={Col}
                        className={styles.mobCountryCodeDropDown}
                        controlId='formGridPhoneNumber'
                      >
                        <div
                          className={styles.mobileCountryCodes}
                          onClick={() =>
                            this.modalToggle(
                              'countryCode',
                              'mobCountryCodeLabel',
                              values.countryCode
                            )
                          }
                        >
                          {this.state.mobCountryCodeLabel}
                          <Image className={styles.countryCodeArrow} name='dropdownArrow.svg' />
                        </div>
                        {this.state.modalShow && (
                          <CountryCodeModal
                            subShow={this.state.modalShow}
                            SubOnHide={this.modalHide}
                            title={this.state.modalTitle}
                            subTitle={this.state.modalSubTitle}
                            modalLabel={this.state.modalLabel}
                            defaultValue={this.state.defaultValue}
                            handleCodeChange={this.setCountryCodeValue}
                            {...this.props}
                          />
                        )}
                      </Form.Group>
                    )}
                    <Form.Group as={Col} controlId='formGridPhoneNumber'>
                      <Field
                        type='text'
                        name='phone'
                        className={
                          values.phoneNumberExists || !values.isValidPhone
                            ? styles.emailError
                            : null
                        }
                        component={ValidatedFormInputField}
                        fieldWithoutSpace={false}
                        onBlur={(e) => {
                          props?.handleBlur(e);
                          const trimmedVal = setValue('phone', values?.phone, false);
                          isTrimmedPhoneValid(
                            values.countryCode,
                            values.phone,
                            setFieldValue,
                            'isValidPhone'
                          );
                          if (trimmedVal && values.isValidPhone && values.countryCode) {
                            let intlPhoneNumber = `${values.countryCode + '' + trimmedVal}`;
                            checkCandidatePhoneAPI(intlPhoneNumber)
                              .then((response) => {
                                if (response.data.data.data !== null) {
                                  setFieldValue('phoneNumberExists', true);
                                } else {
                                  setFieldValue('phoneNumberExists', false);
                                }
                              })
                              .catch((error) => {
                                //commenting this to avoid redundant erros 
                                //  toast.error(getErrorMessage(error));
                                setFieldValue('phoneNumberExists', false);
                              });
                          }
                        }}
                      />
                      {!errors.phone && !values.isValidPhone && (
                        <div className={styles.emailErrorMsg}>
                          {!values.isValidPhone ? 'Please provide a valid Phone number.' : ''}
                        </div>
                      )}
                    </Form.Group>
                  </Form.Row>
                  <Form.Label>Alternate Mobile Number</Form.Label>
                  <Form.Row>
                    {!isMobileOnly ? (
                      <Field
                        type='text'
                        name='altCountryCode'
                        defaultValue={values.altCountryCode}
                        options={countryNames}
                        className='countryCodeDropDown'
                        filterLabel={countryOptions}
                        component={CustomValidatedSelect}
                        onChange={(e) => {
                          if (values.altPhone && e) {
                            isTrimmedPhoneValid(
                              e,
                              values.altPhone,
                              setFieldValue,
                              'isAltValidPhone'
                            );
                          }
                        }}
                      />
                    ) : (
                      <Form.Group
                        as={Col}
                        className={styles.mobCountryCodeDropDown}
                        controlId='formGridPhoneNumber'
                      >
                        <div
                          className={styles.mobileCountryCodes}
                          onClick={() =>
                            this.modalToggle(
                              'altCountryCode',
                              'mobAltCountryCodeLabel',
                              values.altCountryCode
                            )
                          }
                        >
                          {this.state.mobAltCountryCodeLabel}
                          <Image className={styles.countryCodeArrow} name='dropdownArrow.svg' />
                        </div>
                      </Form.Group>
                    )}
                    <Form.Group as={Col} controlId='formGridAltPhoneNumber'>
                      <Field
                        type='text'
                        name='altPhone'
                        className={!values.isAltValidPhone ? styles.emailError : null}
                        component={ValidatedFormInputField}
                        onBlur={(e) => {
                          props.handleBlur(e);
                          setValue('altPhone', values?.altPhone, false);
                          isTrimmedPhoneValid(
                            values.altCountryCode,
                            values?.altPhone,
                            setFieldValue,
                            'isAltValidPhone'
                          );
                        }}
                      />
                      {!values.isAltValidPhone && (
                        <div className={styles.emailErrorMsg}>
                          {!values.isAltValidPhone ? 'Please provide a valid Phone Number.' : ''}
                        </div>
                      )}
                    </Form.Group>
                  </Form.Row>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Employee ID</Form.Label>
                  <Field
                    type='text'
                    name='employeeId'
                    className={values.employeeIdExists ? styles.emailError : null}
                    component={ValidatedFormInputField}
                    onBlur={(e) => {
                      props?.handleBlur(e);
                      const trimmedEmployeeIdVal = setValue('employeeId', values?.employeeId, true);
                      if (trimmedEmployeeIdVal && !errors.employeeId) {
                        checkCandidateEmployeeIdAPI(trimmedEmployeeIdVal).then((response) => {
                          if (response.data.data.data) {
                            setFieldValue('employeeIdExists', true);
                          } else {
                            setFieldValue('employeeIdExists', false);
                          }
                        });
                      }
                    }}
                  />
                  {!errors.employeeId && values.employeeIdExists && (
                    <div className={styles.emailErrorMsg}>
                      {values.employeeIdExists ? 'Employee Id already exists' : ''}
                    </div>
                  )}
                </Form.Group>
                <Form.Group>
                  <Form.Label>Universal Account Number</Form.Label>
                  <Field
                    type='text'
                    name='uanNumber'
                    component={ValidatedFormInputField}
                    onBlur={(e) => {
                      setValue('uanNumber', values?.uanNumber, false);
                      props?.handleBlur(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    Resume
                    {!values.formConfig.isResumeOptional ? <span>*</span> : null}
                  </Form.Label>
                  <Field
                    name='resume'
                    files='resumeFile'
                    candidateId={parsedJwtDetail?.data?.companyId}
                    component={ValidatedFileSelect}
                    fileValue={values.resumeFile}
                    setIsUploading={setIsUploading}
                    uploadToServer={'s3Upload'}
                    linkFieldName={'resumeLink'}
                    defaultField={false}
                    handleErrorCallback={(value) => {
                      setResumeError(value);
                    }}
                  />
                  <div className={styles.resumeErrorMsg}>
                    <ErrorMessage name='resumeLink' />
                  </div>
                </Form.Group>
                <Form.Group className={styles.formGroups}>
                  <Form.Label>Category</Form.Label>
                  <Form.Row>
                    <Col lg={isAdmin ? 9 : 12} md={isAdmin ? 9 : 12}>
                      <DropdownList
                        data={categories}
                        textField='categoryName'
                        valueField='id'
                        defaultValue={''}
                        value={values.category_id}
                        className={'serviceDropdownContainer'}
                        containerClassName={'adminCardAccess'}
                        selectIcon={
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            color={'#C5C5C5'}
                            style={{ marginRight: '10px', fontSize: '14px' }}
                          />
                        }
                        onChange={(value) => {
                          setFieldValue('category_id', value.id);
                        }}
                      />
                    </Col>
                    {isAdmin ? (
                      <Col
                        lg={3}
                        md={3}
                        style={{ padding: '0 5px', display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          onClick={() => {
                            setModalDetails({
                              modalTitle: 'Create Category',
                              modalSubTitle: 'Name',
                              modalButton: 'Create',
                              modalPlaceholder: 'Category Name'
                            });
                            setShowCatModal(true);
                          }}
                          className={styles.addBtn}
                        >
                          Add new category
                        </Button>
                      </Col>
                    ) : null}
                  </Form.Row>
                </Form.Group>
                <Form.Group className={styles.formGroups}>
                  <Form.Label>Tag</Form.Label>
                  <Form.Row>
                    <Col lg={isAdmin ? 9 : 12} md={isAdmin ? 9 : 12}>
                      <Select
                        isMulti
                        placeholder='No tags'
                        name='tags'
                        components={{ tagsSeparator }}
                        options={
                          props.createCandConfig && props.createCandConfig.tags
                            ? props.createCandConfig.tags
                            : []
                        }
                        getOptionLabel={(option) => capitalize(option.category)}
                        getOptionValue={(option) => option.id}
                        styles={tagDropdownStyles}
                        isClearable={false}
                        noOptionsMessage={() => 'No Tags found'}
                        value={values.tags}
                        onChange={(value) => {
                          setFieldValue('tags', value);
                        }}
                      />
                    </Col>
                    {isAdmin ? (
                      <Col
                        lg={3}
                        md={3}
                        style={{ padding: '0 5px', display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          onClick={() => {
                            setModalDetails({
                              modalTitle: 'Create Tag',
                              modalSubTitle: 'Name',
                              modalButton: 'Create',
                              modalPlaceholder: 'Tag Name'
                            });
                            setShowCatModal(true);
                          }}
                          className={styles.addBtn}
                        >
                          Add new tag
                        </Button>
                      </Col>
                    ) : null}
                  </Form.Row>
                </Form.Group>
                <Form.Group>
                  <Form.Label className={styles.formConsent}>
                    Consent <span>*</span>
                  </Form.Label>
                  {props?.createCandConfig?.consentType === 'UNDERTAKING_LETTER' && (
                    <div className={styles.radioBtn}>
                      <Field
                        name='isConsentUndertakingLetter'
                        component={ValidatedRadioFields}
                        disabled={!props?.createCandConfig?.consentUndertakingLetterUrl}
                        options={[
                          {
                            value: '1',
                            label: `Consent Undertaking Letter by ${values?.companyName}`
                          }
                        ]}
                      />
                      <div className={styles.consentSentence}>
                        Through this undertaking, the client (you) hereby acknowledges and agrees
                        that it is solely responsible for collecting consent and has collected the
                        same from the candidate before proceeding/initiating the background check.
                        By proceeding further you also acknowledge that
                        <br />
                        <br />
                        a) SpringVerify will not collect consent from the candidate or the client
                        (as outlined in the consent undertaking letter)
                        <br />
                        b) The candidate is aware of the verification activity to be performed on
                        them
                        <br />
                        c) The candidate has provided their written consent to the client for the
                        same
                      </div>
                      <Field
                        name='isConsentUndertakingLetter'
                        component={ValidatedRadioFields}
                        options={[
                          {
                            value: '2',
                            label: 'Ignore the Consent Undertaking Letter'
                          }
                        ]}
                      />
                    </div>
                  )}
                  {values?.isConsentUndertakingLetter === '2' ? (
                    <div style={{ marginTop: '4px' }}>
                      {!values.email ? (
                        <Field
                          className={styles.consentLabel}
                          custom
                          name='consentDoc'
                          component={Checkbox}
                          label={
                            <div className={styles.noEmailConsent}>
                              <div>Ask candidate for consent</div>
                              <div>
                                (You cannot ask candidate for consent as you have not added an email
                                address)
                              </div>
                            </div>
                          }
                          disabled={!values.email}
                        />
                      ) : (
                        <Field
                          className={styles.consentLabel}
                          custom
                          name='consentDoc'
                          component={Checkbox}
                          label='Ask Candidate for Consent'
                          onChange={() => {
                            setFieldValue('consentDoc', !values.consentDoc);
                            setFieldValue('consentLink', '');
                            setFieldValue('consent', '');
                            setFieldValue('consentFile', null);
                          }}
                        />
                      )}
                      {values.email && !values.consentDoc && (
                        <div className={styles.consentUncheckMsg}>
                          Unchecking this option acknowledges that the consent of the candidate has
                          been taken by you for this verification.
                        </div>
                      )}
                    </div>
                  ) : null}
                  {values?.isConsentUndertakingLetter === '2' ? (
                    <div>
                      {!values.consentDoc || !values.email ? (
                        <Form.Group>
                          <Form.Label>Upload Manual Consent Document</Form.Label>
                          <Field
                            required={true}
                            name='consent'
                            candidateId={parsedJwtDetail?.data?.companyId}
                            className='consentFile'
                            component={ValidatedFileSelect}
                            setIsUploading={setIsConsentUploading}
                            fileValue={values.consentFile}
                            uploadToServer={'s3Upload'}
                            linkFieldName={'consentLink'}
                            files='consentFile'
                            defaultField={false}
                            handleErrorCallback={(value) => {
                              setConsentError(value);
                            }}
                          />
                          <div className={styles.consentDocErrorMsg}>
                            <ErrorMessage name='consent' />
                          </div>
                        </Form.Group>
                      ) : null}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <Form.Label className={styles.required}>
                    Who will fill the BGV form? <span>*</span>
                  </Form.Label>
                  <div className={styles.radioBtn}>
                    <Field
                      name='invite'
                      component={ValidatedRadioFields}
                      options={bgvFiller}
                      onChange={(e) => {
                        onChangeInvite(e);
                      }}
                    />
                    <div className={styles.genderRadioError}>
                      <ErrorMessage name='invite' />
                    </div>
                  </div>
                </Form.Group>
                {values.invite === '1' && (
                  <div className={styles.accordionContainer}>
                    <Accordion>
                      <Card className={styles.accordionContainerCard}>
                        <Accordion.Toggle
                          as={Card.Header}
                          eventKey='0'
                          className={styles.accordionContainerHeader}
                          onClick={() => decoratedOnClick(0)}
                        >
                          <span className={styles.inviteMailHeading}>
                            Add Note to Candidate (in Invite Email)
                          </span>
                          {activeAccordion === 0 ? (
                            <Image name={'UpAngle.svg'} svg={'UpAngle.svg'} />
                          ) : (
                            <Image name={'DownAngle.svg'} svg={'DownAngle.svg'} />
                          )}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey='0'>
                          <Card.Body className={styles.cardBody}>
                            <Form.Group controlId='inviteEmail'>
                              <Form.Control
                                as='textarea'
                                rows={3}
                                name='hrInviteNote'
                                value={values?.hrInviteNote}
                                placeholder='Type a note...'
                                className={styles.accordionTextarea}
                                onInput={(event) => {
                                  if (event.target.value.length > 160) {
                                    event.target.value = event.target.value.slice(0, 160);
                                  }
                                }}
                                onChange={(e) => {
                                  setFieldValue('hrInviteNote', e.target.value);
                                }}
                              />
                            </Form.Group>
                            <div
                              className={styles.textareaCharacterLimit}
                              style={
                                charCount == 160 || (charCount < 10 && charCount > 0)
                                  ? { color: '#DC3545' }
                                  : null
                              }
                            >
                              Characters {charCount} out of 160
                            </div>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </div>
                )}
                <div className={styles.btnGrid}>
                  <Button
                    className={true ? styles.inviteBtn : styles.disabledButton}
                    type='submit'
                    disabled={!isValidForm}
                  >
                    Continue
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
      {showSuccessModal ? (
        <AdminModals
          show={showSuccessModal}
          onHide={() => {
            setShowSuccessModal(false);
          }}
          content={
            modalDetails.modalTitle === 'Create Tag'
              ? 'Tag created successfully'
              : 'Category created successfully'
          }
        />
      ) : null}
      {showCatModal ? (
        <CategoryModals
          show={showCatModal}
          onHide={(value) => {
            if (value === 'reload tag' || value === 'reload category') {
              refreshTags();
              setShowSuccessModal(true);
            }
            setShowCatModal(false);
          }}
          title={modalDetails.modalTitle}
          subTitle={modalDetails.modalSubTitle}
          button={modalDetails.modalButton}
          placeholder={modalDetails.modalPlaceholder}
          toDelete={values}
        />
      ) : null}
    </>
  );
};
